// Kopieren Sie diesen gesamten Code und ersetzen Sie damit den Inhalt von A5MyInvoices.js

import React, { useState, useEffect } from "react";
import { Alert, Table, Button, Container, Spinner, Form, Pagination } from "react-bootstrap";
import userService from "../services/user.service";  // Pfad ggf. anpassen

const showURI= process.env.REACT_APP_API_URL;

const InvoiceManagerADM = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("invoice_date"); // Geändert auf invoice_date als Standard
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    loadInvoices();
  }, [currentPage, searchTerm, sortField, sortOrder]);

  const loadInvoices = async () => {
    setApiErrors("");
    setLoading(true);
    try {
      // Der Aufruf wurde angepasst und sendet keine seller_id mehr mit.
      const response = await userService.getInvoicesADM({
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder,
      });
      setInvoices(response.data.invoices);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setApiErrors("Ein Fehler ist aufgetreten: Rechnungen konnten nicht geladen werden.");
    } finally {
      setLoading(false);
    }
  };
  
  const translateStatus = (status) => {
    switch (status) {
      case 'pending':
        return 'Ausstehend';
      case 'paid':
        return 'Bezahlt';
      case 'canceled':
        return 'Storniert';
      default:
        return status;
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  // +++ ANFANG DES KORREKTEN CODES +++
  const downloadInvoice = async (invoiceId) => {
    try {
      // Diese Funktion sollte im user.service auf die Route GET /api/test/invoicesadm/pdf/:id verweisen
      const response = await userService.downloadInvoiceADM(invoiceId);

      const contentDisposition = response.headers['content-disposition'];
      let filename = `rechnung_${invoiceId}.pdf`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        if (filenameMatch && filenameMatch.length > 1) {
          filename = filenameMatch[1];
        }
      }

      filename = filename.replace(/(\.pdf)[\W_]+$/, '$1');

      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(link.href);

    } catch (error) {
      const errorMsg = error.response && error.response.status === 404 
        ? "Fehler: Die PDF-Datei für diese Rechnung wurde auf dem Server nicht gefunden."
        : "Fehler beim Herunterladen der Rechnung. Bitte versuchen Sie es erneut.";
      setApiErrors(errorMsg);
    }
  };

  const viewInvoicePDF = async (invoiceId) => {
    try {
      const response = await userService.downloadInvoiceADM(invoiceId);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener");
    } catch (error) {
      setApiErrors("Die Rechnung konnte nicht angezeigt werden. Bitte versuchen Sie es erneut.");
    }
  };
  // +++ ENDE DES KORREKTEN CODES +++
  return (
      <Container>
        <h1>Rechnungsverwaltung</h1>
        {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
        <Form.Group controlId="searchInvoices" className="mb-3">
          <Form.Label>Suche nach Rechnungs-Nr. oder Käufer</Form.Label>
          <Form.Control
            type="text"
            placeholder="Suchen..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Form.Group>
        {loading && <div className="text-center"><Spinner animation="border" /> <span className="ms-2">Lade Rechnungen...</span></div>}
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th onClick={() => handleSortChange("invoice_number")}>Rechnungs-Nr.</th>
              <th onClick={() => handleSortChange("buyer_name")}>Käufer</th>
              <th onClick={() => handleSortChange("invoice_date")}>Rechnungsdatum</th>
              <th onClick={() => handleSortChange("invoice_total")}>Nettobetrag</th>
              <th onClick={() => handleSortChange("tax")}>Steuer</th>
              <th onClick={() => handleSortChange("invoice_brut_total")}>Bruttobetrag</th>
              <th onClick={() => handleSortChange("status")}>Status</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {invoices.length > 0 ? (
              invoices.map((invoice) => (
                <tr key={invoice.invoice_id}>
                  <td>{invoice.invoice_number}</td>
                  <td>{invoice.buyer_name || 'N/A'}</td>
                  <td>{new Date(invoice.invoice_date).toLocaleDateString('de-DE')}</td>
                  <td>{invoice.invoice_total} {invoice.currency}</td>
                  <td>{invoice.tax} {invoice.currency}</td>
                  <td>{invoice.invoice_brut_total} {invoice.currency}</td>
                  <td>{translateStatus(invoice.status)}</td>
                  <td>
                    <Button
                      variant="info"
                      onClick={() => viewInvoicePDF(invoice.invoice_id)}
                      className="me-2 mb-1"
                      size="sm"
                    >
                      Anzeigen
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => downloadInvoice(invoice.invoice_id)}
                      className="mb-1"
                      size="sm"
                    >
                      Herunterladen
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">Keine Rechnungen gefunden.</td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination>
          {[...Array(totalPages)].map((_, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === currentPage}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      </Container>
    );



};

export default InvoiceManagerADM;